import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1022b4a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-title"]
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "float_button" }
const _hoisted_4 = { class: "company-footer" }

import CommonDownloadButton from '../components/CommonDownloadButton.vue';
import Template000 from '../components/template/Template-000.vue';
import AppLinkStat from '../stats/AppLinkStat';
import AbilityParamsUtil from '../bridge/AbilityParamsUtil';
import PageParamsUtil from '../../utils/PageParamsUtil';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadView',
  setup(__props) {

const { t } = useI18n();

// document.addEventListener(
//   'touchstart',
//   function (event) {
//     if (event.touches.length > 1) {
//       event.preventDefault();
//     }
//   },
//   {
//     capture: false,
//     passive: false,
//   },
// );
onMounted(() => {
  AppLinkStat.eventAbilityPageShow(
    AbilityParamsUtil.getAbilityName(),
    AbilityParamsUtil.getAbilityBusinessId(),
    PageParamsUtil.getPageUrl(),
  );
});

return (_ctx: any,_cache: any) => {
  const _directive_title = _resolveDirective("title")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "root",
    "data-title": _unref(t)('page.downloadTitle')
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(Template000)))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(CommonDownloadButton)))
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('page.companyName')), 1)
  ], 8, _hoisted_1)), [
    [_directive_title]
  ])
}
}

})